module.exports = __webpack_public_path__ + "img/twitter.05a6cad3.svg";